export default __webpack_public_path__ + "static/media/current_children.87224f81.png";